"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SchedulerInstalled = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const labels_1 = __importDefault(require("@/app/shared/i18n/labels"));
const SchedulerInstalled = () => {
    return ((0, jsx_runtime_1.jsxs)("div", { className: 'flex-center flex-column gap-40px w-full py-150px', children: [(0, jsx_runtime_1.jsx)("img", { src: '/assets/images/omnito.svg', width: 100 }), (0, jsx_runtime_1.jsx)("div", { className: 'text-title-xl-med text-gray-80', children: labels_1.default.MEETING_BOOKER_INSTALLED })] }));
};
exports.SchedulerInstalled = SchedulerInstalled;
